import React from 'react';

import { UiKit } from 'components';
import { useReturnModeConfig } from '../context';
import { RETURN_MODES } from '../stubs';

export default function Form() {
  const { data, errors, onChange, isProcessing } = useReturnModeConfig();

  return (
    <UiKit.Radio.Group
      gap={12}
      name="return_mode"
      value={data.mode}
      onChange={mode => onChange({ mode })}
      disabled={isProcessing}
      error={errors.mode}
    >
      <UiKit.Radio.Card
        value={RETURN_MODES.ADVANCED}
        label="Refunds, exchanges, and store credit"
        description="Your customers can choose how they want to resolve a return. They can get their money back, exchange for a different product, or take store credit. ShipStation updates Shopify with refund and inventory updates automatically."
      />
      <UiKit.Radio.Card
        value={RETURN_MODES.BASIC}
        label="Return labels only"
        description="Your customers get a return label and ship the item back. You handle refunds, exchanges, and inventory in Shopify."
      />
    </UiKit.Radio.Group>
  );
}
